// Action Types for Workflow Design Submission
export const CREATE_WORKFLOW_DESIGN_REQUEST = "CREATE_WORKFLOW_DESIGN_REQUEST";
export const CREATE_WORKFLOW_DESIGN_SUCCESS = "CREATE_WORKFLOW_DESIGN_SUCCESS";
export const CREATE_WORKFLOW_DESIGN_FAILURE = "CREATE_WORKFLOW_DESIGN_FAILURE";

export const GET_WORKFLOW_DESIGN_TICKET_REQUEST =
  "GET_WORKFLOW_DESIGN_TICKET_REQUEST";
export const GET_WORKFLOW_DESIGN_TICKET_SUCCESS =
  "GET_WORKFLOW_DESIGN_TICKET_SUCCESS";
export const GET_WORKFLOW_DESIGN_TICKET_FAILURE =
  "GET_WORKFLOW_DESIGN_TICKET_FAILURE";

export const LIST_WORKFLOW_DESIGN_TICKETS_REQUEST =
  "LIST_WORKFLOW_DESIGN_TICKETS_REQUEST";
export const LIST_WORKFLOW_DESIGN_TICKETS_SUCCESS =
  "LIST_WORKFLOW_DESIGN_TICKETS_SUCCESS";
export const LIST_WORKFLOW_DESIGN_TICKETS_FAILURE =
  "LIST_WORKFLOW_DESIGN_TICKETS_FAILURE";

export const UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST =
  "UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST";
export const UPDATE_WORKFLOW_DESIGN_TICKET_SUCCESS =
  "UPDATE_WORKFLOW_DESIGN_TICKET_SUCCESS";
export const UPDATE_WORKFLOW_DESIGN_TICKET_FAILURE =
  "UPDATE_WORKFLOW_DESIGN_TICKET_FAILURE";

export const DELETE_WORKFLOW_DESIGN_TICKET_REQUEST =
  "DELETE_WORKFLOW_DESIGN_TICKET_REQUEST";
export const DELETE_WORKFLOW_DESIGN_TICKET_SUCCESS =
  "DELETE_WORKFLOW_DESIGN_TICKET_SUCCESS";
export const DELETE_WORKFLOW_DESIGN_TICKET_FAILURE =
  "DELETE_WORKFLOW_DESIGN_TICKET_FAILURE";

export const CHECK_WORKFLOW_DESIGN_STATUS_REQUEST =
  "CHECK_WORKFLOW_DESIGN_STATUS_REQUEST";
export const CHECK_WORKFLOW_DESIGN_STATUS_SUCCESS =
  "CHECK_WORKFLOW_DESIGN_STATUS_SUCCESS";
export const CHECK_WORKFLOW_DESIGN_STATUS_FAILURE =
  "CHECK_WORKFLOW_DESIGN_STATUS_FAILURE";

// Action Creators

// Create Workflow Design
export const createWorkflowDesignRequest = (payload) => ({
  type: CREATE_WORKFLOW_DESIGN_REQUEST,
  payload,
});

export const createWorkflowDesignSuccess = (ticket) => ({
  type: CREATE_WORKFLOW_DESIGN_SUCCESS,
  payload: ticket,
});

export const createWorkflowDesignFailure = (error) => ({
  type: CREATE_WORKFLOW_DESIGN_FAILURE,
  payload: error,
});

// Get Workflow Design Ticket
export const getWorkflowDesignTicketRequest = (payload) => ({
  type: GET_WORKFLOW_DESIGN_TICKET_REQUEST,
  payload,
});

export const getWorkflowDesignTicketSuccess = (ticket) => ({
  type: GET_WORKFLOW_DESIGN_TICKET_SUCCESS,
  payload: ticket,
});

export const getWorkflowDesignTicketFailure = (error) => ({
  type: GET_WORKFLOW_DESIGN_TICKET_FAILURE,
  payload: error,
});

// List Workflow Design Tickets
export const listWorkflowDesignTicketsRequest = (payload) => ({
  type: LIST_WORKFLOW_DESIGN_TICKETS_REQUEST,
  payload,
});

export const listWorkflowDesignTicketsSuccess = (tickets) => ({
  type: LIST_WORKFLOW_DESIGN_TICKETS_SUCCESS,
  payload: tickets,
});

export const listWorkflowDesignTicketsFailure = (error) => ({
  type: LIST_WORKFLOW_DESIGN_TICKETS_FAILURE,
  payload: error,
});

// Update Workflow Design Ticket
export const updateWorkflowDesignTicketRequest = (payload) => ({
  type: UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST,
  payload,
});

export const updateWorkflowDesignTicketSuccess = (ticket) => ({
  type: UPDATE_WORKFLOW_DESIGN_TICKET_SUCCESS,
  payload: ticket,
});

export const updateWorkflowDesignTicketFailure = (error) => ({
  type: UPDATE_WORKFLOW_DESIGN_TICKET_FAILURE,
  payload: error,
});

// Delete Workflow Design Ticket
export const deleteWorkflowDesignTicketRequest = (payload) => ({
  type: DELETE_WORKFLOW_DESIGN_TICKET_REQUEST,
  payload,
});

export const deleteWorkflowDesignTicketSuccess = (response) => ({
  type: DELETE_WORKFLOW_DESIGN_TICKET_SUCCESS,
  payload: response,
});

export const deleteWorkflowDesignTicketFailure = (error) => ({
  type: DELETE_WORKFLOW_DESIGN_TICKET_FAILURE,
  payload: error,
});

// Check Workflow Design Status
export const checkWorkflowDesignStatusRequest = (payload) => ({
  type: CHECK_WORKFLOW_DESIGN_STATUS_REQUEST,
  payload,
});

export const checkWorkflowDesignStatusSuccess = (status) => ({
  type: CHECK_WORKFLOW_DESIGN_STATUS_SUCCESS,
  payload: status,
});

export const checkWorkflowDesignStatusFailure = (error) => ({
  type: CHECK_WORKFLOW_DESIGN_STATUS_FAILURE,
  payload: error,
});
